﻿require('../css/global.css');

var app = {
    init: function () {
        this.Components.init();
        this.Header.init();
        this.Sidenav.init();
        this.Pages.init();
    },

    Components: {
        init: function () {
            this.CookiePopup.init();
            this.Tab.init();
        },

        CookiePopup: {
            init: function () {
                if (sessionStorage.getItem('pops') !== 'visible') {
                    setTimeout(function () {
                        $('#cookiePopup').addClass('visible');
                    }, 1000);
                    $('#cookiePopup a.close-btn').click(function () {
                        $('#cookiePopup').removeClass('visible');
                        sessionStorage.setItem('pops', 'visible');
                    });
                }
            }
        },

        Tab: {
            init: function () {
                this.toggle();
            },

            toggle: function () {
                $('.tab__header').on('click', e => {
                    let tgt = $(e.currentTarget).closest('.tab');

                    tgt.siblings('.tab').removeClass('active');
                    tgt.hasClass('active') ? tgt.removeClass('active') : tgt.addClass('active');
                });
            }
        }
    },

    Header: {
        init: function () {
            this.highlightActivePage();
            this.toggleOnScroll();
        },

        highlightActivePage: function () {
            let page = window.location.pathname,
                links = $('.header__nav a');

            links.each((idx, link) => {
                if (
                    $(link).attr('data-url') === page ||
                    page === '/newsletters' && $(link).attr('data-url') === '/latest-news' ||
                    page === '/applications' && $(link).attr('data-url') === '/planning' ||
                    page === '/amendments' && $(link).attr('data-url') === '/planning' ||
                    page === '/consultation-materials' && $(link).attr('data-url') === '/planning')
                    $(link).addClass('active')
            });

        },

        toggleOnScroll: function () {
            $(window).on('scroll', () => {
                $(window).scrollTop() > 0 ? $('#header').addClass('highlight') : $('#header').removeClass('highlight');
            });
        }
    },

    Sidenav: {
        init: function () {
            this.toggle();
        },

        close: function () {
            $('#header, .sidenav__menu a').removeClass('active');
            $('#btnMenu .text').text('MENU');
        },

        open: function () {
            $('#header').addClass('active');
            $('#btnMenu .text').text('CLOSE');
            setTimeout(function () { $('.sidenav__menu a:nth-of-type(1)').addClass('active') }, 75);
            setTimeout(function () { $('.sidenav__menu a:nth-of-type(2)').addClass('active') }, 150);
            setTimeout(function () { $('.sidenav__menu a:nth-of-type(3)').addClass('active') }, 225);
            setTimeout(function () { $('.sidenav__menu a:nth-of-type(4)').addClass('active') }, 300);
        },

        toggle: function () {
            $('#btnMenu').on('click', function () {
                $('#header').hasClass('active') ? app.Sidenav.close() : app.Sidenav.open();
            });
        }
    },

    Pages: {
        init: function () {
            $('#contactUs').length > 0 && this.Contact.moveMapOnMouseMove();
            $('#home').length > 0 && this.Home.init();
            $('#news').length > 0 && this.News.init();
            $('#ourTeam').length > 0 && this.Team.init();
        },

        Home: {
            init: function () {
                this.displaySection();
                this.showSectionsOnScroll();
                this.Slider.init();
            },

            displaySection: function () {
                var sections = $('section:not(#homeHero)');

                sections.each(idx => {
                    var yTrigger = ($(sections[idx]).offset().top - $(window).height() / 2) - 50;
                    $(document).scrollTop() > yTrigger && $(sections[idx]).addClass('active');
                });
            },

            showSectionsOnScroll: function () {
                $(window).on('scroll', function () {
                    app.Pages.Home.displaySection();
                });
            },

            Slider: {
                init: function () {
                    this.onBtnClick();
                    this.onBtnHover();
                    this.update();
                },

                onBtnClick: function () {
                    $('.slider').on('click', 'button', e => {
                        var dir = '';

                        $('.slide.active').removeClass('active');
                        $('.slide.preview').removeClass('preview');
                        if ($(e.currentTarget).hasClass('next')) {
                            dir = 'next';
                            $('.slide.prev').removeClass('prev');
                            $('.slide.next').removeClass('next').addClass('active');
                        } else {
                            dir = 'prev';
                            $('.slide.prev').removeClass('prev').addClass('active');
                            $('.slide.next').removeClass('next');
                        }
                        this.update(true, dir);
                    });
                },

                onBtnHover: function () {
                    $('.slider').on('mouseenter', 'button', e => {
                        $($(e.currentTarget)).hasClass('prev') ? $('.slide.prev').addClass('preview') : $('.slide.next').addClass('preview');
                    }).on('mouseleave', 'button', e => {
                        $('.slide.preview').removeClass('preview');
                    });
                },

                update: function (isClick, dir) {
                    var slides = $('.slide'),
                        isClick = isClick,
                        dir = dir;

                    slides.each((idx, slide) => {
                        if ($(slide).hasClass('active')) {
                            if (idx === 0) {
                                $(slides[slides.length - 1]).addClass('prev');
                                $(slides[1]).addClass('next');
                            } else if (idx === slides.length - 1) {
                                $(slides[idx - 1]).addClass('prev');
                                $(slides[0]).addClass('next');
                            } else {
                                $(slides[idx - 1]).addClass('prev');
                                $(slides[idx + 1]).addClass('next');
                            }
                        }
                    });
                    $('.slide.' + dir).addClass('preview');
                }
            },
        },

        News: {
            init: function () {
                this.toggleArticlesLength();
            },

            toggleArticlesLength: function () {
                $('.article__toggle').on('click', e => {
                    let tgt = $(e.currentTarget),
                        art = tgt.closest('.article');

                    art.toggleClass('active');
                    art.hasClass('active') ? tgt.text('READ LESS') : tgt.text('READ MORE');
                });
            }
        },

        Team: {
            init: function () {
                this.highlightProfileOnClick();
                this.removeHighlightedProfile();
            },

            highlightProfileOnClick: function () {
                $('.profile').on('click', function (e) {
                    e.preventDefault();

                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                    $('#ourTeamBio').html(
                        '<div class="panel flexbox between top wrap bg--white">' +
                            '<div class="cross">' +
                                '<span></span>' +
                                '<span></span>' +
                            '</div>' +
                            '<img src="' + $('img', this).attr('src').split('.')[0] + '--wide.jpg" alt="' + $('img', this).attr('alt') + '" />' +
                            '<div class="biography">' +
                                '<h3 class="font--csb">' + $('.role', this).text() + '</h3>' +
                                '<h2 class="font--cs">' + $('.name', this).text() + '</h2>' +
                                '<p>' + $(this).attr('data-bio') + '</p>' +
                                '<a href="mailto:info@sjwsservices.com?subject=FAO ' + $('.name', this).text() + '">Email</a>' +
                            '</div>' +
                        '</div>'
                    );
                    setTimeout(function () {
                        $('#ourTeamBio').addClass('active');
                        $('html, body').animate({ scrollTop: 0 }, 250);
                    }, 30);

                });
            },

            removeHighlightedProfile: function () {
                $('#ourTeamBio').on('click', '.cross', function () {
                    $('#ourTeamBio, .profile').removeClass('active');
                    $('#ourTeamBio .panel').remove();
                });
            }
        }
    }
};

$(document).ready(function () { app.init(); })